<mat-card style="margin-top:30px;margin-left:10px;margin-right:30px;width:96%;height:100%;min-height: 600px;">
 
    <div class="container-fluid">
               

        <!-- 20241031 :: Marked for Deletion :: Ken Moss -->
       <!-- <div class="row">
           <div class="col-2">
               <strong>Invoice Period:</strong> <br /> 
               {{invoicePeriod}}
           </div>
           <div class="col-2">
               <strong>Invoice No:</strong> <br />
               {{invoiceNumber}}
           </div>
           <div class="col-4">
               <strong>Customer:</strong> <br />
               {{customerName}}
           </div>
           <div class="col-2">
               <strong>Invoice Amount:</strong> <br />
               {{invoiceAmount | currency}}
           </div>
           <div class="col-2">
               <div *ngIf="this.msgService.currentInvoiceBalance >= 0">
                   <strong>Balance: </strong> <br />
                   {{this.msgService.currentInvoiceBalance | currency}}
               </div>
               <div *ngIf="this.msgService.currentInvoiceBalance < 0">
                   <strong>Balance: </strong> <br/>
                   <span style="color:red;">({{(this.msgService.currentInvoiceBalance * -1) | currency}})</span>   
               </div>
           </div>
       </div> -->
   
   
      
   
       <div class="row" style="margin-top:10px;">
          
       </div>
       <div class="row mt-4" >
           <div class="col-12">
               <strong>Add Adjustment Details</strong>
           </div>
       </div>
       <hr/>
       
       <div class="row" style="margin-top:10px;margin-left:10px;margin-right:10px;">
           <div class="col-1">
               <button mat-icon-button class="mt-0 ml-2" (click)="onResetAddNewAdjustmentData()">
                   <mat-icon style="margin-left:2px;color:black" >restart_alt</mat-icon>
                   Reset
               </button>
           </div>
           <div class="col-2">
                <select id="adjustmentInvoiceLineItem"  class="form-select" 
                   aria-label="Default select example" 
                   style="font-size:12px;margin-right:5px;margin-top:7px;"  
                   (change)="onBillingInvoiceLineItemSelected()">
                   <option [value]="0"
                  >
                   -- SELECT INVOICE LINE ITEM --
                   </option>
                   <option *ngFor="let billingLine of invoiceBillingLines" [value]="billingLine.primaryKey" 
                   >
                   {{billingLine.lineItemName}}  --   
                   {{billingLine.totalAmount + billingLine.calcedAdjustmentAmount | currency}}  --
                   {{billingLine.description}}
                   </option>
             </select>
             </div>
           <div class="col-1">
           
               <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                   <mat-label>Date</mat-label>
                   <input id="adjustmentInvoiceLineCurrentDate"
                       matInput placeholder="Date" 
                       readonly=true   
                       value={{getCurrentDate()}}
                       (blur)="onValidateAdjustmentData()"
                       >
                 </mat-form-field>
           </div>
           <div class="col-1">
              
               <mat-form-field  appearance="fill" style="width:100%;font-size:12px;color:red;">
                       <mat-label>Net</mat-label>
                       <input matInput placeholder="Net" 
                       id="adjustmentAmountNet" 
                       twoDigitDecimaNumberDirective
                       (keyup)="onCalcAmountFromNet()"
                       readonly={{adjustmentDataEntryLocked}}
                       (blur)="onValidateAdjustmentData()"
                       (onblur)="onValidateAdjustmentData()"
                       >
               </mat-form-field>
           </div>
           <div class="col-1">
               <mat-form-field appearance="fill" style="width:100%;font-size:12px;color:red;">
                   <mat-label>Gross</mat-label>
                   <input matInput placeholder="Gross" 
                   id="adjustmentAmountGross"
                   twoDigitDecimaNumberDirective
                   (keyup)="onCalcAmountFromGross()"
                   readonly={{adjustmentDataEntryLocked}}
                   (blur)="onValidateAdjustmentData()"
                   (onblur)="onValidateAdjustmentData()"
                   >
                 </mat-form-field>
           </div>
           <div class="col-2">
               <select id="adjustmentReasons"  class="form-select" 
                   aria-label="Default select example" 
                   style="font-size:12px;margin-right:5px;margin-top:7px;"
                   (change)="onValidateAdjustmentData()"  >
                   <option  [value]="0" >
                       -- SELECT REASON --
                   </option>
                   <option *ngFor="let adjustmentReason of invoiceAdjustmentReasons" 
                       [value]="adjustmentReason.adjustmentReasonId" 
                       >
                       {{adjustmentReason.reason}} 
                   
                   </option>
             </select>
           </div>
         
           <div class="col-2">
               <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                   <mat-label>Comment</mat-label>
                   <input matInput placeholder="Description" id="adjustmentComment"
                   (keyup)="onValidateAdjustmentData()">
                 </mat-form-field>
           </div>
        
           <div class="col-1">
                   <button class="btn btn-primary btn-sm mt-3 ace-blue" style="margin-left:20px;" (click)="onSubmitInvoiceAdjustment()" [disabled]="disableAdjustmentSubmitButtonFlag">Submit</button>
           </div>
           
         
       </div>
   
   
       <div class="row" style="margin-top:10px;margin-left:10px;margin-right:10px;">
           <div class="col-1">
              
           </div>
           <div class="col-2">
              
             </div>
           <div class="col-1">
           </div>
           <div class="col-1">
               <div *ngIf="adjustmentValidationMessages.netAmountMessage !==''">
                   <span class="generic-error-presentation">{{adjustmentValidationMessages.netAmountMessage}}</span>
               </div>
                 
           </div>
           <div class="col-1">
               <div *ngIf="adjustmentValidationMessages.grossAmountMessage !==''">
                   <span class="generic-error-presentation">{{adjustmentValidationMessages.grossAmountMessage}}</span>
               </div>
           </div>
           <div class="col-2">
               <div *ngIf="adjustmentValidationMessages.adjustmentReasonMessage !==''">
                   <span class="generic-error-presentation">{{adjustmentValidationMessages.adjustmentReasonMessage}}</span>
               </div>
           </div>
         
           <div class="col-2">
              <div *ngIf="adjustmentValidationMessages.commentMessage !==''">
                  <span class="generic-error-presentation">{{adjustmentValidationMessages.commentMessage}}</span>
              </div>
           </div>
        
           <div class="col-1">
           </div>
         
       </div>
   
       
       
       <div *ngIf="adjustmentBeingAdded" class="spinner-wrapper">
           <mat-spinner></mat-spinner>
       </div>
   
       <ng-container class="ml-4" *ngIf="completedAdjustmentsGB?.length">
           <strong style="font-size:14px;margin-left:20px;margin-top:30px;">Adjusted Invoice Lines</strong>
           <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
           <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;">
               <th style="font-size:12px;">
                   Date
               </th>
   
               <th style="font-size:12px;width:30%;">
                   Description
               </th>
           
            
   
               <th style="font-size:12px;">
                   Reason
               </th>
   
               <th style="font-size:12px;">
                   Comment
               </th>
   
               <th style="font-size:12px;text-align: right;">
                   Net Amount
               </th>
   
               <th style="font-size:12px;text-align: right;">
                   Tax
               </th>
   
               <th style="font-size:12px;text-align: right;">
                   Gross Amount
               </th>
              
             
               
               <tr *ngFor="let adjustmentLine of completedAdjustmentsGB;let i = index">
                   <td style="font-size:12px;">
                      {{adjustmentLine.adjustmentDate | date:'shortDate'}}
                   </td>
   
                   <td style="font-size:12px;">
                       {{adjustmentLine.customerName}} -- {{adjustmentLine.description}}
                    </td>
   
                    <td style="font-size:12px;">
                       {{adjustmentLine.reason}}
                    </td>
   
                    <td style="font-size:12px;">
                       {{adjustmentLine.comments}}
                    </td>
               
                    <td style="font-size:12px;color:red;text-align: right;">
                       {{adjustmentLine.adjustmentAmount | currency}}
                   </td>
   
                   <td style="font-size:12px;color:red;text-align: right;">
                       {{adjustmentLine.taxAmount | currency}}
                   </td>
   
                   <td style="font-size:12px;color:red;text-align: right;">
                       {{adjustmentLine.grossAdjustmentValue | currency}}
                   </td>
               </tr>
           
           </table>   
           </div>
       </ng-container>
   
       <ng-container class="ml-4" *ngIf="completedAdjustmentsMI?.length">
           <strong style="font-size:14px;margin-left:20px;margin-top:30px;">Adjusted Invoice Lines</strong>
           <div class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
           <table style="width:100%;margin-left:2px;margin-right:2px;margin-top:10px;">
               <th style="font-size:12px;">
                   Date
               </th>
   
               <th style="font-size:12px;width:30%;">
                   Description
               </th>
           
            
   
               <th style="font-size:12px;">
                   Reason
               </th>
   
               <th style="font-size:12px;">
                   Comment
               </th>
   
               <th style="font-size:12px;text-align: right;">
                   Net Amount
               </th>
   
               <th style="font-size:12px;text-align: right;">
                   Tax
               </th>
   
               <th style="font-size:12px;text-align: right;">
                   Gross Amount
               </th>
              
             
               
               <tr *ngFor="let adjustmentLine of completedAdjustmentsMI;let i = index">
                   <td style="font-size:12px;">
                      {{adjustmentLine.adjustmentDate | date:'shortDate'}}
                   </td>
   
                   <td style="font-size:12px;">
                       {{adjustmentLine.revenueType}} -- {{adjustmentLine.description}}
                    </td>
   
                    <td style="font-size:12px;">
                       {{adjustmentLine.reason}}
                    </td>
   
                    <td style="font-size:12px;">
                       {{adjustmentLine.comments}}
                    </td>
               
                    <td style="font-size:12px;color:red;text-align: right;">
                       {{adjustmentLine.adjustmentAmount | currency}}
                   </td>
   
                   <td style="font-size:12px;color:red;text-align: right;">
                       {{adjustmentLine.taxAmount | currency}}
                   </td>
   
                   <td style="font-size:12px;color:red;text-align: right;">
                       {{adjustmentLine.grossAdjustmentValue | currency}}
                   </td>
               </tr>
           
           </table>   
           </div>
       </ng-container>
   
   </div>
   
   </mat-card>